module.exports = __webpack_public_path__ + "img/twitterorange.a54ffe64.svg";